/**
 * Screen — the shared vertical-stack frame every management console screen shares (header + body with a
 * consistent gap). Mirrors the admin/inventory inline Screen so the console sections stack identically.
 */
import type { ReactNode } from "react";

export function Screen({ children }: { children: ReactNode }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--nv-s-5)" }}>{children}</div>
  );
}

/** A responsive auto-fit grid for KPI tiles / module chips. */
export function TileGrid({ children, min = 200 }: { children: ReactNode; min?: number }) {
  return (
    <div
      style={{
        display: "grid",
        gap: "var(--nv-s-4)",
        gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`,
      }}
    >
      {children}
    </div>
  );
}
